import { RemoteGetPersonByCPF } from 'data/usecases';
import { makeApiUrlEntitiesPersons } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetPersonByCPF = (): RemoteGetPersonByCPF => {
  return new RemoteGetPersonByCPF(
    makeApiUrlEntitiesPersons(),
    makeAxiosHttpClient(),
  );
};
